import React from 'react';
import { useRecoilState } from 'recoil';
import { selectedOrderAtom } from '../../../Services/_states/index.js';
import { BackButton } from '../../Shared/BackButton/index.jsx';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
// import { BlobProvider } from '@react-pdf/renderer';
// import Invoice from './invoice.jsx';
import { MRT_ColumnDef } from 'material-react-table';
import { generateInvoicePDF } from './invoice.jsx';

const OrderDetails: React.FC = () => {
  const [selectedOrder, setSelectedOrder] = useRecoilState(selectedOrderAtom);

  const products = selectedOrder?.products || [];
  const shippingAddress = selectedOrder?.shipping_address || {};
  const billingAddress = selectedOrder?.billing_address || {};

  const data = products.map((product) => ({
    Image: product.product_image,
    'Item Name': product.product_name,
    SKU: '',
    Quantity: product.quantity,
    Price: product.item_price,
    Total: product.item_price * product.quantity,
  }));

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: 'Item Name',
      header: 'Item Name',
      size: 200,
      Cell: ({ row }) => (
        <Box alignItems="center">
          <img
            src={row.original.Image}
            alt={row.original['Item Name']}
            width={20}
            height={20}
            style={{ marginRight: 10 }}
          />
          <span>{row.original['Item Name']}</span>
        </Box>
      ),
    },
    { accessorKey: 'SKU', header: 'SKU', size: 120 },
    { accessorKey: 'Quantity', header: 'Quantity', size: 100 },
    { accessorKey: 'Price', header: 'Price', size: 100 },
    {
      accessorKey: 'Total',
      header: 'Total',
      size: 120,
      Footer: ({ table }) => {
        const total = table
          .getCoreRowModel()
          .rows.reduce((sum, row) => sum + Number(row.original.Total || 0), 0);
        return (
          <Box
            sx={{
              backgroundColor: '#f8f9fa',
              padding: '8px 12px',
              textAlign: 'right',
              fontWeight: 'bold',
            }}
          >
            <div>Total Amount:</div>
            <div>₹ {total.toFixed(2)}</div>
          </Box>
        );
      },
    },
  ];

  const renderAddress = (address) =>
    Object.entries(address)
      .filter(([_, value]) => value !== null && value !== undefined && value !== '')
      .map(([key, value], index) => (
        <Box key={index} display="flex" justifyContent="space-between" mb={1}>
          <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '}
          <span>{value?.toString()}</span>
        </Box>
      ));

  return (
    <Box
      sx={{
        padding: '5px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h5" fontWeight="bold">
          Order Detail → {selectedOrder?.order_id || ''}
        </Typography>
        <BackButton onClick={() => setSelectedOrder({})} />
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardHeader title="Customer & Order" />
            <CardContent>
              {Object.entries(selectedOrder?.customer_detail || {})
                .filter(([key]) => !['wa_flow_response_params', 'flow_token'].includes(key))
                .map(([key, value], index) => (
                  <Box key={index} display="flex" justifyContent="space-between" mb={1}>
                    <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '}
                    <span>{value?.toString()}</span>
                  </Box>
                ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardHeader title="Shipping Address" />
            <CardContent>{renderAddress(shippingAddress)}</CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardHeader title="Billing Address" />
            <CardContent>{renderAddress(billingAddress)}</CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box mt={4}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            Items Ordered → {selectedOrder?.order_id || ''}
          </Typography>
          {/* <BlobProvider document={<Invoice data={selectedOrder} />}>
            {({ loading, url }) => (
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!loading && url) {
                    window.open(url, '_blank');
                  }
                }}
              >
                Invoice
              </Button>
            )}
          </BlobProvider> */}
          <Button
            variant="contained"
            onClick={async (e) => {
              e.stopPropagation();
              const doc = await generateInvoicePDF(selectedOrder);
              doc.save(`invoice_${selectedOrder?.order_id || 'order'}.pdf`);
            }}
          >
            Invoice
          </Button>
        </Box>

        <CommonTable
          columns={columns}
          data={data}
          enableRowSelection={false}
          enableTableFooter={true}
          muiTableContainerProps={{ sx: { maxHeight: 400, width: '100%' } }}
          state={{
            showColumnFilters: false,
            isLoading: false,
            rowSelection: {},
          }}
        />
      </Box>
    </Box>
  );
};

export default OrderDetails;
